.k3{gap:0.125rem;}